import * as React from "react";
import {FC, JSX, useEffect} from "react";
import {HorizontalMenu} from "./HorizontalMenu";
import Box from "@mui/material/Box";
import EpidStatus, {EpidStatusProps} from "./Admin/EpidStatus/EpidStatus.tsx";
// @ts-ignore TODO ts-ignore
import {UploadFile} from "./UploadFile";
// @ts-ignore TODO ts-ignore
import {getUrl} from "../requests";
// @ts-ignore TODO ts-ignore
import Report from "./Report/Report";
import clsx from "clsx";
import css from "./ZapleczeAdmin.module.css";
import '../index.css';
import Typography from "@mui/material/Typography";
import MenuConst from "./MenuConst";
import {GoodNews, GoodNewsProps} from "./Admin/GoodNews/GoodNews.tsx";
import Profile from "./Model/Profile.ts";

export class ZapleczeAdminMenuList {
    static NONE         = MenuConst.NONE;
    static RAPORT       = MenuConst.ADMIN + 1;
    static STATUSES     = MenuConst.ADMIN + 2;
    static LOCAL_NEWS   = MenuConst.ADMIN + 3;
    static SET_HELP_PDF = MenuConst.ADMIN + 4;
    static SZABLONY     = MenuConst.ADMIN + 5;

    static arr = (() => {
        let arr = [];

        arr[ZapleczeAdminMenuList.SET_HELP_PDF]  = "Wyślij instrukcję";
        arr[ZapleczeAdminMenuList.STATUSES]      = "Statusy";
        arr[ZapleczeAdminMenuList.LOCAL_NEWS]    = "Wiadomości lokalne";
        arr[ZapleczeAdminMenuList.RAPORT]        = "Raport";
        arr[ZapleczeAdminMenuList.SZABLONY]      = "Szablony";

        return arr;
    })();

    static admin = (() => {
        let admin = [];
        admin[ZapleczeAdminMenuList.NONE] = true;
        admin[ZapleczeAdminMenuList.LOCAL_NEWS] = true;
        admin[ZapleczeAdminMenuList.STATUSES] = true;
        admin[ZapleczeAdminMenuList.RAPORT] = true;
        admin[ZapleczeAdminMenuList.SET_HELP_PDF] = true;
        admin[ZapleczeAdminMenuList.SZABLONY] = true;
        return admin;
    })();
}

export interface ZapleczeAdminMenuProps {
    setMenuIx: (index: number) => void;
    isAdmin: boolean;
}

export const ZapleczeAdminMenu: FC<ZapleczeAdminMenuProps> = ( props) : JSX.Element=> {
    return (
        <HorizontalMenu
            menuList={ZapleczeAdminMenuList.arr}
            menuAdmin={ZapleczeAdminMenuList.admin}
            isAdmin={props.isAdmin}
            setMenuIx={(index) => {
                props.setMenuIx(index);
            }}
        />
    );
}

export interface ZapleczeAdminPanelProps {
    token: string;
    selectedContext: string;
    menuIx: number;
    isAdmin: boolean;
}

export const ZapleczeAdminPanel : FC<ZapleczeAdminPanelProps> = (props) : JSX.Element => {
    const adminProfile = new Profile('Admin', '');

    const changeHelpFile = ():JSX.Element => {
        return (
            <Box>
                <UploadFile
                    token={props.token}
                    targetUrl={`${getUrl()}/api/v1/admin/load-help-file`}
                />
            </Box>
        );
    };

    const raport = (): JSX.Element => {
        return (
            <Report
                isAdmin={props.isAdmin}
                context={props.selectedContext}
                auth={{
                    user: props.token,
                    epid: props.selectedContext,
                }}
            />
        )
    }

    const goodNews = (): JSX.Element => {

        const goodNewsProps: GoodNewsProps = {
            token: props.token,
            profile: adminProfile,
        }

        return (
            <GoodNews {...goodNewsProps}/>
        )
    }

    const statuses = ():JSX.Element => {
        
        console.log('statuses');
        const statusesProps: EpidStatusProps = {
            token: props.token,
            profile: adminProfile,
        }

        return (
            <EpidStatus {...statusesProps}/>
        )
    }

    const szablony = () => {
        // Lista kluczowych kolorów z Twojego pliku CSS
        const kolory = [
            "--color-primary-green",
            "--color-primary-celadon",
            "--color-primary-blue",
            "--color-primary-black",
            "--color-primary-orange",
            "--color-primary-purple",
            "--color-primary-red",
            "--color-primary-white",
            "--color-light-gray",
            "--color-middle-gray",
            "--color-dark-gray",
            "--color-white",
            "--color-gray" ,
            "--color-background-table-head" ,
            "--color-background-data-head" ,
            "--color-background-data-body" ,
            "--color-background-data-footer",
            "--color-background-error:",
            "--color-background-success",
            "--color-background-warning",
            "--color-border-data",
            "--color-border-error",
            "--color-border-success",
            "--color-border-warning",
            "--color-text-error",
            "--color-text-success",
            "--color-text-data",
            "--color-text-warning",
            "--color-button-accept-background",
            "--color-button-accept-background-hover",
            "--color-button-accept-text",
            "--color-button-accept-text-hover",
            "--color-button-accept-border",
            "--color-button-accept-border-hover",
            "--color-button-reject-background" ,
            "--color-button-reject-background-hover",
            "--color-button-reject-text",
            "--color-button-reject-text-hover",
            "--color-button-reject-border",
            "--color-button-reject-border-hover",
            "--color-selected-item-underline",
            "--color-blue-shadow",
            "--color",
            "--color-background",
            "--color-background-apla",
            "--box-shadow",
            "--box-shadow-bottom",
            "--box-radius",
            "--color-soft-green",
            "--color-soft-blue",
            "--color-soft-celadon",
            "--color-soft-orange",
            "--color-soft-purple",
            "--color-soft-red",
            "--color-soft-gray",
            "--color-soft-sand",



            "--color-background-error",
            "--color-background-success",
            "--color-background-warning"
        ];


        return (

            <Box sx={{
                        paddingLeft: '10%',
                        paddingRight: '10%',
                    }}
            >


                <Box className={clsx(css.colory, 'apla')}
                     sx={{
                         p: 2,
                     }}
                >
                    <Typography variant="h6" sx={{ mb: 2, fontFamily: "Montserrat" }}>
               Wiadomości          Próbnik kolorów lokalni.pl
                    </Typography>

                    <Box  className={clsx(css.colory)}
                          sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 2
                    }}>
                        {kolory.map((colorVar) => (
                            <Box key={colorVar} sx={{ textAlign: 'center' }}>
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        backgroundColor: `var(${colorVar})`,
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        mb: 0.5
                                    }}
                                />
                                <Typography sx={{ fontSize: '10px', fontFamily: 'Lato' }}>
                                    {colorVar.replace('--color-', '')}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        );
    }

    const none = () => {
        return (
            <Box>
                <Typography variant="h6">Wybierz opcję</Typography>
            </Box>
        );
    }

    useEffect(() => {
        console.log('menuIx', props.menuIx);
        switch (props.menuIx) {
         case ZapleczeAdminMenuList.SET_HELP_PDF:
                changeHelpFile();
                break;
        }
    },[props.menuIx]);


    return (
        <Box className={clsx(css.adminPanel)}>
            {props.menuIx === ZapleczeAdminMenuList.RAPORT && raport()}
            {props.menuIx === ZapleczeAdminMenuList.STATUSES && statuses()}
            {props.menuIx === ZapleczeAdminMenuList.LOCAL_NEWS && goodNews()}
            {props.menuIx === ZapleczeAdminMenuList.SET_HELP_PDF && changeHelpFile()}
            {props.menuIx === ZapleczeAdminMenuList.SZABLONY && szablony()}
            {props.menuIx === ZapleczeAdminMenuList.NONE && none()}
        </Box>
    );
}